import './SliderNotch.5db80f240c7a56e3c8d49745e00347fe.css';
export default {"notch":"_notch_bxpor_1"};